import { Box, Typography, Button, Container, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import "../style/About.css";

function About() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" className="about-container">
            <Paper elevation={3} className="about-paper">
                <Box textAlign="center" p={4}>
                    <ConstructionIcon 
                        color="primary" 
                        sx={{ fontSize: 80, mb: 2 }} 
                    />
                    <Typography 
                        variant="h3" 
                        component="h1" 
                        gutterBottom
                        color="primary"
                    >
                        About Us Coming Soon
                    </Typography>
                    <Typography 
                        variant="h6" 
                        component="p" 
                        paragraph
                        sx={{ mb: 3 }}
                    >
                        We're currently working on our about us page to bring you the best experience.
                    </Typography>
                    <Typography 
                        variant="body1" 
                        component="p" 
                        color="text.secondary"
                        sx={{ mb: 4 }}
                    >
                        Check back soon.
                    </Typography>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate('/')}
                            sx={{ px: 4 }}
                        >
                            Go Back
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
}

export default About;